<template>
    <main-banner
        :title="$t('games.x01_banner_title')"
        :players="online ? '2' : '1 - 4'"
        :difficulty="$t('game_difficulty.beginner')"
        :image="imageSrc"
        id="x01"
        @start-game="selectMatch('501')"
        :coming-soon="false"
    />
</template>

<script>
import MainBanner from './Main.vue'
// TODO: replace with dedicated x01 banner image once available
import img from '@images/games/x01/BannerBackground.jpg'
import { mapStores } from 'pinia'
import { useMatchStore } from '@/stores/match.js'
import { useAuthStore } from '@/stores/auth.js'

export default {
    components: {
        MainBanner,
    },
    props: {
        online: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useMatchStore, useAuthStore),
        imageSrc() {
            return img
        },
    },
    methods: {
        async selectMatch(type) {
            await this.matchStore.selectMatchType(
                type,
                this.authStore,
                this.$router,
                this.$toast,
                this.online,
            )
        },
    },
}
</script>
